export default [
  {
    path: '/exam/marking/examTask',
    meta: { auth: ['Exam-Marking', 'Region-Exam-Marking'] },
    component: r => require(['@/v3/modules/marking/views/read-task.vue'], r),
    name: 'exam-marking-task'
  },
  {
    path: '/exam/marking/error',
    name: 'exam-marking-error',
    meta: { auth: ['Exam-Marking', 'Region-Exam-Marking'] },
    component: r => require(['@/v3/modules/marking/views/error'], r)
  },
  {
    path: '/exam/marking/setting-new/:id',
    name: 'exam-marking-setting-new',
    meta: { auth: ['Grading-Division', 'Region-Grading-Division'], moreAuths: ['exam'] },
    component: r => require(['@/v3/modules/marking/views/setting'], r)
  },
  {
    path: '/exam/marking/readPaper/:id',
    name: 'exam-marking-readPaper',
    meta: { auth: ['Exam-Marking', 'Region-Exam-Marking'] },
    component: r => require(['@/v3/modules/marking/views/readPaper'], r)
  },
  {
    path: '/exam/marking/paperReview',
    name: 'exam-marking-paperReview',
    meta: { auth: ['Exam-Marking', 'Region-Exam-Marking'] },
    component: r => require(['@/v3/modules/marking/views/paperReview'], r)
  },
  {
    path: '/exam/marking/region-setting/:id',
    meta: { auth: 'Grading-Division' },
    component: r => require(['@/v3/modules/marking/views/regionSetting'], r),
    name: 'exam-marking-region-setting'
  }
]
